// Generated by CoffeeScript 2.7.0
var Admin__Settings__PushPackagesController;

import GenerateMorePopover from 'trunks/controllers/admin/settings/nav.js';

import GeneratePushPackageSidebar from 'trunks/vue/admin/compositions/push_package/push_package_sidebar.js';

import PushPackagePayload from 'trunks/vue/admin/compositions/push_package/push_package_payload.js';

export default Admin__Settings__PushPackagesController = (function() {
  class Admin__Settings__PushPackagesController extends Skylark.App.BaseController {
    index() {
      return this._generatePushPackageSidebar('namespace', '');
    }

    show() {
      var id, push_package_container;
      this.resourceUrl = '/admin/settings/push_packages';
      push_package_container = DomMaster.find("#push_package_container").node;
      id = this.getIds()[0];
      this._generatePushPackageSidebar('namespace', id);
      return new PushPackagePayload({
        el: push_package_container,
        propsData: {
          resourceUrl: `${this.resourceUrl}/${id}`
        }
      });
    }

  };

  Admin__Settings__PushPackagesController.include(GenerateMorePopover);

  Admin__Settings__PushPackagesController.include(GeneratePushPackageSidebar);

  return Admin__Settings__PushPackagesController;

}).call(this);
